import { attributesToProps } from 'html-react-parser';
import { getWordpressStyles, renderChild } from '@/app_lib/htmlParser/parsers/parserOptions';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';

export const DivParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { style, className, ...rest } = props;

  const newClasses = getWordpressStyles(className?.toString() || '');

  const newStyles = className?.toString()?.includes('wp-block-jetpack-gif-wrapper') ? {} : style;

  return (
    <div
      className={cn(newClasses, className).replace('size-full', '')}
      style={newStyles as React.CSSProperties}
      {...rest}
    >
      {renderChild(children)}
    </div>
  );
};
